export const commonEnvironment = {
  /**指纹收费版js域名 */
  fpEndpoint: 'https://fiuspzry.athena25.com',
  /**指纹收费版apikey */
  fpApiKey: '1vM7oo4cXMdXBeHnAfCP',
};
